import { createFileRoute } from "@tanstack/react-router";
import { EditFournisseurPage } from "@/features/achats/components/fournisseurs/EditFournisseurPage";

export const Route = createFileRoute("/_app/achats/fournisseurs/$id/edit")({
  staticData: {
    title: "Modifier fournisseur",
    showInBreadcrumb: true,
  },
  component: EditFournisseurPage,
});
